import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Wordmark } from "../../components/Header";
import { usePageMeta } from "../../components/Common";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLogin = () => {
  const [checking, setChecking] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const error = location.state?.error;

  usePageMeta("Admin Sign In — English for Leaders", undefined, "/admin/login", {
    noindex: true,
  });

  useEffect(() => {
    let live = true;
    fetch(`${API}/auth/me`, { credentials: "include" })
      .then((r) => {
        if (!r.ok) throw new Error();
        return r.json();
      })
      .then((user) => navigate("/admin", { replace: true, state: { user } }))
      .catch(() => live && setChecking(false));
    return () => {
      live = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
      redirectUrl
    )}`;
  };

  return (
    <div className="flex min-h-[80vh] items-center justify-center bg-offwhite px-6">
      <div
        className="w-full max-w-md border border-navy/10 bg-white p-10 text-center"
        data-testid="admin-login"
      >
        <div className="mx-auto inline-block text-left">
          <Wordmark />
        </div>
        <h1 className="mt-8 font-display text-2xl tracking-tight text-navy">
          Editorial Dashboard
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-charcoal/70">
          Sign in with your authorised Google account to manage articles.
        </p>
        {error && (
          <p
            className="mt-4 border border-crimson/30 bg-crimson/5 px-4 py-3 text-sm font-semibold text-crimson"
            data-testid="admin-login-error"
          >
            {error}
          </p>
        )}
        <button
          type="button"
          data-testid="google-signin-button"
          onClick={signIn}
          disabled={checking}
          className="mt-8 inline-flex w-full items-center justify-center gap-2 rounded-sm bg-crimson px-6 py-3.5 text-sm font-bold text-white transition-colors hover:bg-crimson-dark disabled:opacity-60"
        >
          {checking ? "Checking access…" : "Continue with Google"}
        </button>
      </div>
    </div>
  );
};

export default AdminLogin;
